import { fetchAPI } from "./utils";

export interface AppDownloadsPoint {
    date: string;
    ios: number;
    android: number;
}

export interface AppDownloadsResponse {
    ios: number;
    android: number;
    total: number;
    series: AppDownloadsPoint[];
    updatedAt: string | null;
    dataFreshness: { ios: string | null; android: string | null };
    earliestAvailable: { ios: string | null; android: string | null };
    hasData: boolean;
}

export interface GetAppDownloadsParams {
    token: string;
    startDate?: Date | string | null;
    endDate?: Date | string | null;
}

export const getAppDownloads = async ({
    token,
    startDate,
    endDate,
}: GetAppDownloadsParams): Promise<AppDownloadsResponse> => {
    return fetchAPI<AppDownloadsResponse>("/get-app-downloads", "POST", { startDate, endDate }, token);
};
